import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Input from '@/common/components/Input';
import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import { ButtonWrapper } from '../../Attachments.styled';
import { WORKFLOWS_OPTIONS } from '../../constants/workflows';
import useAttachmentForm from './useAttachmentForm';

const AttachmentForm = ({
	setShow,
	selectedFile,
	languageOptions,
	reload = () => {},
}) => {
	const hook = useAttachmentForm({
		setShow,
		selectedFile,
		languageOptions,
		reload,
	});

	return (
		<PopUp setShow={setShow} style={{ overflow: 'visible' }}>
			{hook.isLoading && <Loading />}
			<form onSubmit={hook.formik.handleSubmit} style={{ overflow: 'visible' }}>
				<SelectInput
					color={Colors.darkBlue}
					name='Language'
					options={languageOptions}
					value={hook.formik.values.language}
					selected={hook.formik.values.language}
					setSelected={(value) => {
						hook.formik.setFieldValue('language', value);
					}}
					width={110}
					selectWidth={110}
				/>
				<SelectInput
					color={Colors.darkBlue}
					name='Workflow'
					options={WORKFLOWS_OPTIONS}
					value={hook.formik.values.workflow}
					selected={hook.formik.values.workflow}
					setSelected={(value) => {
						hook.formik.setFieldValue('workflow', value);
					}}
					width={110}
					selectWidth={150}
				/>
				<Input
					width={110}
					inputWidth={300}
					name='Filename'
					color={Colors.darkBlue}
					value={hook.formik.values.filename}
					onChange={hook.formik.handleChange}
					id='filename'
					required
					requiredSign={true}
				/>
				<Input
					required={!selectedFile}
					type='file'
					name='File'
					color={Colors.darkBlue}
					width={110}
					inputWidth={300}
					onChange={hook.handleFileSelect}
					requiredSign={true}
				/>

				<ButtonWrapper>
					<SubmitButton style={{ marginBottom: '-30px' }} text='Save' />
				</ButtonWrapper>
			</form>
		</PopUp>
	);
};

export default AttachmentForm;
